import { useRef, useEffect } from "react";

/**
 * Runs a fetch callback exactly once on mount, guarding against
 * React StrictMode double-mounting in development.
 *
 * @param {Function} fetchFn - Callback that dispatches the initial fetch.
 * @param {Object}   [options]
 * @param {boolean}  [options.skip=false] - When true the fetch is deferred
 *   until skip becomes false (e.g. waiting for a route param or checking
 *   if data already exists).
 */
const useInitialFetch = (fetchFn, { skip = false } = {}) => {
  const hasRun = useRef(false);
  const fetchRef = useRef(fetchFn);
  fetchRef.current = fetchFn;

  useEffect(() => {
    if (skip || hasRun.current) return;
    hasRun.current = true;
    fetchRef.current();
  }, [skip]);
};

export { useInitialFetch };
